module.exports = __webpack_public_path__ + "assets/godaddy-website-builder.d754b1db.svg";